import { render, staticRenderFns } from "./RolePicker.vue?vue&type=template&id=d0af3424&scoped=true"
import script from "./RolePicker.vue?vue&type=script&lang=js"
export * from "./RolePicker.vue?vue&type=script&lang=js"
import style0 from "./RolePicker.vue?vue&type=style&index=0&id=d0af3424&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0af3424",
  null
  
)

export default component.exports